import { graphql } from "../../../services/wp.api.service";


const query = `
	mutation CheckInToOnlineEvent($id: ID!) {
		updateRegistration(
			input: {
				id: $id,
				checkIn: true
			}
		) {
			registration {
				course {
					node {
						coursesInfo {
							courselink
						}
					}
				}
				registrationstatuses {
					nodes {
						name
					}
				}
			}
		}
	}
`;

export const checkInAndGetLink = (useMutation, options) => useMutation(
	(registrationId) => graphql({
		query,
		variables: {
			id: registrationId
		}
	}).
		then(({ data }) => {
			if (data.errors) {
				throw new Error(data.errors[0].message);
			}

			return data?.data?.updateRegistration?.registration?.course?.node?.coursesInfo;
		}),
	{
		...options
	}
);
